(() => {
  if (window.__ggFooterNewsletterBound) return;
  window.__ggFooterNewsletterBound = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (form.id !== 'gg-footer-newsletter') return;
    event.preventDefault();
    if (form.dataset.ggSubmitState === 'pending' || form.dataset.ggSubmitState === 'success') return;
    if (!form.reportValidity()) return;

    const email = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-gg-newsletter-status]');
    if (!email || !button || !status) return;
    const originalLabel = button.textContent;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);

    form.dataset.ggSubmitState = 'pending';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = status.dataset.submitting;
    email.readOnly = true;
    status.hidden = true;
    status.classList.remove('gg-footer__email-status--ok', 'gg-footer__email-status--err');

    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=THNjP5', {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
        signal: controller.signal,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer newsletter',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email.value.trim(),
                    properties: { source: 'footer-newsletter', offer: '15OFF', page_url: window.location.href },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: 'Xz97Uz' } } }
          }
        })
      });
      if (!response.ok) throw new Error('Subscription request failed');
      form.dataset.ggSubmitState = 'success';
      button.textContent = status.dataset.successLabel;
      status.textContent = status.dataset.success;
      status.classList.add('gg-footer__email-status--ok');
    } catch (error) {
      form.dataset.ggSubmitState = 'error';
      button.disabled = false;
      button.textContent = originalLabel;
      email.readOnly = false;
      status.textContent = status.dataset.error;
      status.classList.add('gg-footer__email-status--err');
    } finally {
      clearTimeout(timeout);
      form.removeAttribute('aria-busy');
      status.hidden = false;
    }
  });
})();
